export const generateRandomNotificationNumber = () => Math.random()

export const getNotificationFromNumber = <T extends any>(
  notifications: T[],
  randomIndex: number
) => notifications[Math.floor(randomIndex * notifications.length)]
